/** Loading dark theme — spinner turquesa + label. */
interface Props {
  label?: string;
}

export function Loading({ label = "Carregando..." }: Props) {
  return (
    <div className="flex items-center gap-3 text-white/60 py-8 justify-center">
      <div className="h-4 w-4 rounded-full border-2 border-indra-turquesa border-t-transparent animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function ErrorBox({ message }: { message: string }) {
  return (
    <div className="bg-indra-negativo/10 border border-indra-negativo/30 rounded-lg p-4 text-sm text-white">
      <p className="font-semibold text-indra-negativo mb-1">Erro ao carregar</p>
      <p className="text-white/80 font-mono text-xs">{message}</p>
    </div>
  );
}
